import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Form from '../../../components/Form/Form'
import RichText from '../../../components/RichText/RichText'

import { fetchClient } from '../../../utils/fetch'

export default function ForgotPassword (props = {
    heading: null,
    richText: null,
    submitBtnText: null,
    successMessage: null
}) {
    const id = 'forgot-password'

    const submitMsg = useRef()

    const [submissionState, setSubmissionState] = useState({
        success: null,
        message: null
    })

    const isDisabled = () => submissionState.success

    const onSubmit = async (e) => {
        const inputEmail = e.target.querySelector(`#${id}-email`)

        const res = await fetchClient
            .post('/auth/change-password/request', {
                json: {
                    email: inputEmail.value
                }
            })
            .catch(err => err)

        const isError = Boolean((res.message || '').length)

        setSubmissionState({
            success: !isError,
            message: res.message
                || props.successMessage
                || 'Check your inbox to complete the password reset.'
        })
    }

    useEffect(() => {
        if (submissionState.message
                && submitMsg.current)
            submitMsg.current.focus()
    }, [submissionState.message])

    return (
        <div className="forgot-password">
            <h1
                className="heading-2 margin-b"
            >
                {props.heading || 'Forgot Password'}
            </h1>
            <RichText
                html={props.richText}
            />
            <Form
                id={id}
                className="forgot-password-form margin-3-t"
                onSubmit={onSubmit}
                disabled={isDisabled()}
                aria-describedby={submissionState.message
                    && `${id}-submit-msg`}
            >
                <div className="form-field-floating margin-3-b">
                    <input
                        id={`${id}-email`}
                        name="email"
                        type="email"
                        autoComplete="on"
                        autoCapitalize="none"
                        spellCheck="false"
                        pattern="[a-zA-Z0-9\._%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,}$"
                        placeholder=" "
                        disabled={isDisabled()}
                        required
                    />
                    <label
                        htmlFor={`${id}-email`}
                    >
                        Email address
                    </label>
                    <p
                        id={`${id}-email-invalid`}
                        role="alert"
                    >
                        A valid email address is required
                    </p>
                </div>
                <div className="row flex-justify-content-space-between flex-align-items-center margin-4-t">
                    <div className="col-auto col-12-sm-down display-inline-flex flex-direction-column">
                        <button
                            className="btn-lg flex-grow-sm-down pad-5-l-sm-up pad-5-r-sm-up"
                            type="submit"
                            disabled={isDisabled()}
                        >
                            {props.submitBtnText || 'Submit'}
                        </button>
                        <p
                            ref={submitMsg}
                            id={`${id}-submit-msg`}
                            className="margin-2-t"
                            role={submissionState.success
                                ? 'status'
                                : 'alert'}
                            style={{
                                display: submissionState.message !== null
                                    && 'block'
                            }}
                            tabIndex="-1"
                        >
                            {submissionState.message}
                        </p>
                    </div>
                    <div className="col-auto col-12-sm-down pad-3-t-sm-down">
                        <Link
                            className="body-3 text-decoration-underline"
                            to="/login"
                        >
                            Return to login
                        </Link>
                    </div>
                </div>
            </Form>
        </div>
    )
}
